var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9029_507710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54736 10.0284V10.5H8.48299V10.0284H8.36749C8.2584 10.0284 8.14611 10.0155 8.03061 9.98985C7.91511 9.95777 7.82207 9.89681 7.75149 9.80698C7.6809 9.71073 7.64561 9.56956 7.64561 9.38348V5.34098H5.58586V5.8126H5.67249C5.78157 5.8126 5.89065 5.82544 5.99974 5.8511C6.10882 5.87677 6.20186 5.93452 6.27886 6.02435C6.35586 6.10777 6.39436 6.23931 6.39436 6.41898V9.40273C6.39436 9.5824 6.35586 9.71714 6.27886 9.80698C6.20828 9.89681 6.11524 9.95777 5.99974 9.98985C5.89065 10.0155 5.78157 10.0284 5.67249 10.0284H5.54736Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46174 4.28223C6.60291 4.38489 6.77295 4.43623 6.97186 4.43623C7.17078 4.43623 7.34082 4.38489 7.48199 4.28223C7.62316 4.17956 7.69374 4.01273 7.69374 3.78173C7.69374 3.54431 7.62316 3.37748 7.48199 3.28123C7.34082 3.17856 7.17399 3.12723 6.98149 3.12723C6.77615 3.12723 6.60291 3.17856 6.46174 3.28123C6.32699 3.37748 6.25961 3.54431 6.25961 3.78173C6.25961 4.01273 6.32699 4.17956 6.46174 4.28223Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM13.125 7C13.125 10.3827 10.3827 13.125 7 13.125C3.61726 13.125 0.875 10.3827 0.875 7C0.875 3.61726 3.61726 0.875 7 0.875C10.3827 0.875 13.125 3.61726 13.125 7Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9029_507710)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.10c81640d040b02493375a24c8a4b0b3.svg";
export { ForwardRef as ReactComponent };